<template>
    <div class="home">
        11111
    </div>
</template>

<script >
import Vue from "vue";
import axios from 'axios';
import storejs from 'storejs';
import {
    eventBus
} from '../assets/js/eventBus.js';
export default Vue.extend({
    name: "home",
    data() {

    },
    created() {
        this.$store.state.bar = false;
    },
    mounted() {
        var that = this;
       
    },
    components: {
      
    },
});
</script>
